function injectStyle (ssrContext) {
  require("!!../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4f588582\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExaminationResult.vue")
}
var Component = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExaminationResult.vue"),
  /* template */
  require("!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4f588582\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExaminationResult.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f588582",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/components/info/components/block/components/ExaminationResult/ExaminationResult.vue
// module id = 00442d37dc3c165920d8
// module chunks = 89